export function isEmpty(inputElement) {
    return (inputElement === undefined || inputElement === null || inputElement === '');
}